import styled from "styled-components";
import colours from "styles/colours";

export const StyledInput = styled.input`
  min-height: 3rem;
  height: auto;
  border-radius: 200px;
  box-shadow: none;
  border: 1px solid ${colours.elexonBlue};
  padding-left: 1rem;

  &:active,
  &:hover {
    outline: none;
    box-shadow: none;
    border: 1px solid ${colours.elexonBlue};
  }
`;
